import BaseService from '_services/rest/base';

/* eslint-disable new-parens */
class BannerService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/banner`;
  }

  getUrlSave(id) {
    if (id) {
      return {
        url: `${this.getUrl()}/${id}`,
      };
    }
    return {
      url: `${this.getUrl()}`,
    };
  }

  getList(params) {
    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getBanner(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteBanner(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  save(model) {
    let formData = new FormData();
    formData = this.setFormData(model, formData);
    const meta = this.getUrlSave(model.id);
    return this.request(meta.url, formData, 'post')
      .catch(err => {
        throw err;
      });
  }
}

export default new BannerService();
